  import React from 'react';
  import { Route } from 'react-router-dom';
  import ConferenceDetail from './pages/ConferenceDetail/index';
  import NumbersCleanup from './pages/NumbersCleanup';
  import SearchResults from './components/Search/SearchResults';
  import CompanyDetail from './pages/CompanyDetail';
  import ConferenceGeolocation from './pages/ConferenceGeolocation';
  import ConferenceStats from './pages/ConferenceStats';
  import SearchNumberLogs from './pages/SearchNumberLogs';
  import OnlineUsers from './pages/OnlineUsers';
  import DelinquencyReport from './pages/DelinquencyReport';
  import HangupReport from './pages/HangupReport';
  import PullConferenceStreams from './PullConferenceStreams';
  import NodeCCMigration from './NodeCCMigration';
  import SubscriberActivityByDay from './pages/SubscriberActivityByDay';
  import NumberAssignment from './pages/NumberAssignment';

  export default [
    <Route exact path="/conference-detail/:id" component={ConferenceDetail} />,
    <Route exact path="/numbers-cleanup" component={NumbersCleanup} />,
    <Route exact path="/search-results" component={SearchResults} />,
    <Route exact path="/company-detail/:id" component={CompanyDetail} />,
    <Route exact path="/conference-geolocation/:id?" component={ConferenceGeolocation} />,
    <Route exact path="/pull-streams/:id?" component={PullConferenceStreams} />,
    <Route exact path="/conference-stats/" component={ConferenceStats} />,
    <Route exact path="/number-search-logs/:id?" component={SearchNumberLogs} />,
    <Route exact path="/online-users" component={OnlineUsers} />,
    <Route exact path="/delinquency-report" component={DelinquencyReport} />,
    <Route exact path="/hangup-report" component={HangupReport} />,
    <Route exact path="/node-cc-migration" component={NodeCCMigration} />,
    <Route exact path="/subscriber-activity" component={SubscriberActivityByDay} />,
    <Route exact path="/number-assignment" component={NumberAssignment} />,
  ];



// WEBPACK FOOTER //
// ./src/routes.js